export const DEFAULT_HELP_CENTER_URL =
  'https://intercom-help.eu/docu-tools-helpcenter/en/'
